import React from "react";
import { Heart } from "lucide-react";

const Logo = ({ light = false, size = "md" }) => {
  const dims = size === "lg" ? "h-14 w-14" : "h-11 w-11";
  const text = size === "lg" ? "text-3xl" : "text-2xl";
  return (
    <a href="#home" className="flex items-center gap-3 group">
      <div
        className={`${dims} rounded-full flex items-center justify-center shrink-0 shadow-md transition-transform duration-300 group-hover:scale-105`}
        style={{
          background:
            "linear-gradient(135deg, #123c74 0%, #1b5aa0 45%, #5aa83a 100%)",
        }}
      >
        <Heart className="h-5 w-5 text-white" fill="white" strokeWidth={1.5} />
      </div>
      <div className="leading-none">
        <div
          className={`${text} font-extrabold tracking-tight`}
          style={{ color: light ? "#ffffff" : "#123c74" }}
        >
          MV<span style={{ color: "#5aa83a" }}>SD</span>
        </div>
        <div
          className="text-[9px] font-semibold tracking-[0.14em] mt-0.5"
          style={{ color: light ? "rgba(255,255,255,0.75)" : "#5aa83a" }}
        >
          MISSION &bull; VALUE &bull; SERVICE &bull; DEDICATION
        </div>
      </div>
    </a>
  );
};

export default Logo;
